import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  quality: string;
  duration: string;
  imageUrl: string;
  featured?: boolean;
}

export default function MovieCard({
  title,
  titleEn,
  category,
  categorySlug,
  year,
  rating,
  quality,
  duration,
  imageUrl,
  featured,
}: MovieCardProps) {
  return (
    <article
      className="group cursor-pointer"
      data-product-shop
    >
      <Link
        to={`/category/${categorySlug}`}
        className="block"
      >
        <div
          className={`relative overflow-hidden rounded-lg ${
            featured ? 'aspect-[16/9]' : 'aspect-[2/3]'
          }`}
        >
          <img
            src={imageUrl}
            alt={`${title} ${category} 高清电影海报 - 星辰影院`}
            title={`${title} - ${quality} ${category}`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2 py-1 rounded-md font-medium whitespace-nowrap">
            {quality}
          </span>
          <span className="absolute top-3 right-3 bg-background-50/90 text-foreground-950 text-xs px-2 py-1 rounded-md font-semibold whitespace-nowrap flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-primary-500 text-[10px]"></i>
            </span>
            {rating}
          </span>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h3 className="text-white font-heading font-bold text-sm md:text-base mb-1 line-clamp-1">
              {title}
            </h3>
            <p className="text-white/70 text-xs mb-2">{titleEn}</p>
            <div className="flex items-center gap-2 text-white/60 text-xs">
              <span className="flex items-center gap-1">
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-time-line text-[10px]"></i>
                </span>
                {duration}
              </span>
              <span>|</span>
              <span>{year}</span>
              <span>|</span>
              <Link
                to={`/category/${categorySlug}`}
                className="text-primary-300 hover:text-primary-200 transition-colors whitespace-nowrap"
              >
                {category}
              </Link>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}